// components/Loader/Spinner.js
import React from "react";
import "./Spinner.css";

const Spinner = () => (
  <div className="spinner-overlay">
    <div className="load-row">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
);

export default Spinner;
